module.exports = __webpack_public_path__ + "assets/adbb5fdc8a8eaf7b6dd1542d6c350b42.png";